// extracted by mini-css-extract-plugin
export default {"textTitle":"StartTx_textTitle__sNdpp","inputContainer":"StartTx_inputContainer__YdT4f","lgInput":"StartTx_lgInput__QWxti"};